import clsx from 'clsx'
import {MessageItemCommonProps, SENDER_TYPE} from '../../definitions'
import {MessageItemWrapper} from './MessageItemWrapper'
import Markdown from 'markdown-to-jsx'
import {useMemo} from 'react'

type MessageItemTextProps = MessageItemCommonProps<string>

export const MessageItemText = ({message, className = ''}: MessageItemTextProps) => {
  const isUserSender = useMemo(() => message.sender === SENDER_TYPE.USER, [message.sender])
  return (
    <MessageItemWrapper
      message={message}
      className={clsx('white-space-normal markdown-wrapper', className)}
    >
      <Markdown
        options={{
          overrides: {
            a: {
              props: {
                target: '_blank',
                rel: 'noopener noreferrer',
                style: isUserSender ? {color: 'white', fontStyle: 'italic'} : undefined,
              },
            },
          },
        }}
      >
        {message.content}
      </Markdown>
    </MessageItemWrapper>
  )
}
